import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  transform: "translate(0 2)",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.237.203a.75.75 0 0 1 1.06.034L4.5 3.653 7.703.237a.75.75 0 1 1 1.094 1.026L5.528 4.75l3.27 3.487a.75.75 0 0 1-1.095 1.026L4.5 5.847 1.297 9.263A.75.75 0 0 1 .203 8.237L3.472 4.75.202 1.263A.75.75 0 0 1 .238.203M11.687 8.5c-.766 0-1.377.52-1.596 1.18a.75.75 0 0 0 1.424.473c.039-.117.123-.153.172-.153h.65c.029 0 .064.011.098.048a.26.26 0 0 1 .065.176c0 .116-.064.19-.114.213l-1.391.649c-.624.29-.995.928-.995 1.596v.568c0 .414.336.75.75.75h2.5a.75.75 0 0 0 0-1.5h-1.689a.2.2 0 0 1 .068-.055l1.391-.649c.615-.287.98-.914.98-1.572 0-.906-.7-1.724-1.663-1.724z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const EditorSubscript = { render };
export {
  EditorSubscript as default,
  render
};
//# sourceMappingURL=EditorSubscript.svg.js.map
